<template>
  <div>
    <!-- Start: Header -->
    <section class="section-header-info">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0)">Booker Tariff</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Company Incentives
                </li>
              </ol>
            </nav>
            <div class="content-header-info">
              <div class="col-sm-12">
                <button
                  v-if="isAllowToCreate"
                  class="btn btn-primary pull-left"
                  @click="createItem()"
                >
                  <span>&#43;</span> Create New
                </button>
                <div class="pl-30 pull-left">
                  <h2>
                    Company Incentives <span><i class="ic-promo"></i></span>
                  </h2>
                  <p>
                    Set all necessary parameters and configuration to support
                    your business.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Header -->

    <!-- Start: Table -->
    <section class="middle-content">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="dataTables_filter">
              <i class="ic-search"></i>
              <input
                type="search"
                class="form-control"
                v-model="table.keyword"
                @keyup="onKeyupKeyword()"
                placeholder="Search Company Name"
              />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="dataTables_length pull-right">
              <label>
                <select
                  class="form-control v-select"
                  v-model="table.pageSize"
                  @change="onChangePageSize()"
                >
                  <option
                    v-for="item in table.pageSizes"
                    :value="item"
                    :key="item"
                  >
                    {{ item }}
                  </option>
                </select>
                Entries</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="table-responsive table-p15">
            <table class="table table-hover table-fix">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Incentive Name</th>
                  <th>Incentive Tier</th>
                  <th class="text-left">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="detail-row" v-for="item in items" :key="item.id">
                  <td>{{ item.companyName }}</td>
                  <td>{{ item.incentiveName }}</td>
                  <td>
                    Tier {{ item.tierOrder }}
                    <strong>
                      {{ printTier(item.tierType, item.tierRate) }}
                    </strong>
                  </td>
                  <td class="text-left">
                    <label class="cursor-pointer">
                      <input
                        type="checkbox"
                        class="control-checkbox"
                        v-model="item.isActive"
                        @change="changeStatus(item)"
                        :disabled="!isAllowToUpdate"
                      />
                      <span class="pl-5 font-weight-normal v-align-middle">
                        {{ item.isActive ? "Active" : "Inactive" }}
                      </span>
                    </label>
                  </td>
                  <td class="text-center">
                    <div class="button-action-wrapper">
                      <button
                        v-if="isAllowToUpdate"
                        class="btn btn-default"
                        type="button"
                        @click="updateItem(item)"
                      >
                        <span>Edit</span>
                      </button>
                      <button
                        v-if="isAllowToDelete"
                        class="btn btn-default"
                        type="button"
                        @click="confirmDelete(item)"
                      >
                        <i class="ic-close"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="dataTables_info --blue25">
              <strong>{{ recordInfo }}</strong>
            </div>
          </div>
          <div class="col-sm-7">
            <nav aria-label="...">
              <paginate
                v-model="table.pageNumber"
                :page-count="table.totalPages"
                :click-handler="onNavigateCallback"
                :prev-text="'Previous'"
                :next-text="'Next'"
                :container-class="'pagination pull-right'"
              >
              </paginate>
            </nav>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Table -->

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="incentivecompanymodal">
      <div class="modal-dialog modal-md">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-sell" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>Company Incentive</h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="summary-error" v-if="$v.model.$error">
                    This form has errors
                  </div>
                  <form @submit.prevent="submit">
                    <div class="form-group">
                      <label class="required">Company</label>
                      <v-select
                        class="v-search-select"
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.companyId.$error,
                        }"
                        placeholder=""
                        label="name"
                        v-model="model.companyId"
                        :options="companies"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.id"
                      ></v-select>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.companyId.required"
                        >Company is required</small
                      >
                    </div>
                    <div class="form-group">
                      <label class="required">Incentive</label>
                      <v-select
                        class="v-search-select"
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.incentiveId.$error,
                        }"
                        placeholder=""
                        label="name"
                        v-model="model.incentiveId"
                        :options="incentives"
                        :clearable="false"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.id"
                        @input="onChangeIncentive(model.incentiveId)"
                      ></v-select>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.incentiveId.required"
                        >Incentive is required</small
                      >
                    </div>
                    <div class="form-group">
                      <label class="required">Incentive Tier</label>
                      <v-select
                        class="v-search-select"
                        :class="{
                          'field-error':
                            isSubmitted && $v.model.incentiveTierId.$error,
                        }"
                        placeholder=""
                        label="label"
                        v-model="model.incentiveTierId"
                        :options="incentiveTiers"
                        :clearable="true"
                        :searchable="true"
                        :filterable="true"
                        :reduce="(option) => option.id"
                      >
                        <template slot="option" slot-scope="option">
                          <div class="phone-wrapper">
                            Tier {{ option.order }}
                            <span style="margin-left: 3px">
                              {{ printTier(option.type, option.rate) }}
                            </span>
                          </div>
                        </template>
                      </v-select>
                      <small
                        class="form-text sts-danger"
                        v-if="isSubmitted && !$v.model.incentiveTierId.required"
                        >Incentive Tier is required</small
                      >
                    </div>
                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
        </div>
      </div>
    </div>

    <deleteModal @submit="submitDelete" />
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import deleteModal from "@/components/shared/DeleteModal";
import companyService from "@/services/master/company/companyService.js";
import incentiveService from "@/services/master/incentive/incentiveService.js";
import incentiveTierService from "@/services/master/incentive/incentiveTierService.js";
import incentiveTierCompanyService from "@/services/master/incentive/incentiveTierCompanyService.js";

export default {
  components: {
    deleteModal,
  },
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
    recordInfo: function () {
      return this.table.totalRecords > 1
        ? `${this.table.totalRecords} Records`
        : `${this.table.totalRecords} Record`;
    },
  },
  data() {
    return {
      table: {
        keyword: "",
        totalPages: 1,
        totalRecords: 0,
        pageNumber: 1,
        pageSize: 25,
        pageSizes: [25, 50, 100],
      },
      isSubmitted: false,
      allPermissions: [],
      formatter: null,
      moneyFormat: null,
      incentives: [],
      incentiveTiers: [],
      companies: [],
      defaultCompanyId: null,
      itemToBeDeleted: null,
      items: [],
      model: {},
      isLoading: false,
      isUpdate: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        companyId: { required },
        incentiveId: { required },
        incentiveTierId: { required },
      },
    };
  },
  async created() {
    this.$helper.scrollTop();
    const publicSettings = await this.$store.dispatch("setting/getAllPublic");
    this.table.pageSize = this.$helper.extractSetting(
      publicSettings,
      "PageSize",
      25
    );

    const profile = await this.$store.dispatch("user/getProfile");
    const permissions = profile.services[this.$route.name];
    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getCompanies();
      await this.getIncentives();
      if (this.incentives) {
        await this.onChangeIncentive(this.incentives[0].id);
      }
      await this.getAll();

      if (
        profile.defaultCompany &&
        this.companies &&
        this.companies.length > 0
      ) {
        const company = this.companies.find(
          (x) => x.id == profile.defaultCompany.id
        );
        if (company) {
          this.defaultCompanyId = company.id;
        }
      }
    }
  },
  mounted() {
    $(this.$refs.incentivecompanymodal).on("hidden.bs.modal", this.closeModal);
  },
  updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-company-incentive-link");
  },
  methods: {
    async onChangePageSize() {
      this.table.pageNumber = 1;
      await this.getAll();
    },
    async onKeyupKeyword() {
      const self = this;
      if (self.timer) {
        clearTimeout(self.timer);
        self.timer = null;
      }
      self.timer = setTimeout(async (_) => {
        self.table.pageNumber = 1;
        await self.getAll();
      }, 500);
    },
    async onNavigateCallback(pageNumber) {
      this.table.pageNumber = pageNumber;
      await this.getAll();
    },
    resetValidations() {
      this.isSubmitted = false;
      this.$v.model.$reset();
    },
    openModal(object) {
      this.resetValidations();
      this.model = Object.assign({}, object);
      $(this.$refs.incentivecompanymodal).modal({
        backdrop: "static",
        keyboard: false,
      });
    },
    closeModal() {
      this.resetValidations();
      this.model = {};
      $(this.$refs.incentivecompanymodal).modal("hide");
    },
    async getIncentives() {
      try {
        this.incentives = await incentiveService.getAllActive();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async getCompanies() {
      try {
        this.companies = await companyService.getAllActive();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async onChangeIncentive(id) {
      try {
        const response = await incentiveTierService.getAll(id);
        this.incentiveTiers = response.items;
        for (let i = 0; i < this.incentiveTiers.length; i++) {
          const tier = this.incentiveTiers[i];
          tier.label = `Tier ${tier.order}`;
        }
        this.moneyFormat = response.moneyFormat;
        if (this.moneyFormat) {
          this.formatter = new Intl.NumberFormat(this.moneyFormat.cultureCode, {
            style: "currency",
            currency: this.moneyFormat.currencyCode,
            currencyDisplay: "code",
            minimumFractionDigits: this.moneyFormat.numberOfDecimal,
          });
        }
        this.model.incentiveTierId = null;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      }
    },
    async getAll() {
      if (!this.isAllowToRead) {
        return;
      }
      try {
        this.isLoading = true;
        let filter = `?page=${this.table.pageNumber}&size=${this.table.pageSize}`;
        if (this.table.keyword !== null && this.table.keyword !== "") {
          filter += `&search=${this.table.keyword}`;
        }
        const response = await incentiveTierCompanyService.getAll(filter);
        this.items = response.data;
        this.table.totalPages = response.totalPages;
        this.table.totalRecords = response.totalRecords;
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    createItem() {
      this.isUpdate = false;
      this.incentiveTiers = [];
      this.openModal({
        companyId: this.defaultCompanyId,
        incentiveId: null,
        incentiveTierId: null,
      });
    },
    async updateItem(item) {
      await this.onChangeIncentive(item.incentiveId);
      item.incentiveTierId = item.tierId;
      this.isUpdate = true;
      this.openModal(item);
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        if (this.isUpdate) {
          await incentiveTierCompanyService.update(this.model);
          this.$notification.success("Successfully updated.", {
            title: "Success",
          });
        } else {
          await incentiveTierCompanyService.create(this.model);
          this.$notification.success("Successfully added.", {
            title: "Success",
          });
        }
        await this.getAll();
        this.closeModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        item.incentiveTierId = item.tierId;
        await incentiveTierCompanyService.update(item);
        this.$notification.success("Successfully updated.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.itemToBeDeleted = item;
      $("#deletemodal").modal();
    },
    async submitDelete() {
      try {
        this.isLoading = true;
        await incentiveTierCompanyService.delete(this.itemToBeDeleted.id);
        this.$notification.success("Successfully deleted.", {
          title: "Success",
        });
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    printTier(type, rate) {
      if (type) {
        switch (type.toLowerCase()) {
          case "percentage":
            return `(${rate}%)`;
          case "fixed":
            return this.moneyFormat
              ? `${this.moneyFormat.currencyCode} ${this.printMoney(rate)}`
              : `(${rate})`;
        }
      }
      return "N/A";
    },
    printMoney(value) {
      return this.formatter
        ? this.formatter
            .format(value)
            .replace(/[a-z]{3}/i, "")
            .trim()
        : value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/sellingTariff/IncentiveCompany.vue